import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
  static targets = ['input'];

  connect() {
    this._onConfirm = (event) => this._handleConfirm(event);
    this.element.addEventListener('file-upload-modal:confirm', this._onConfirm);
  }

  disconnect() {
    this.element.removeEventListener('file-upload-modal:confirm', this._onConfirm);
  }

  _handleConfirm(event) {
    const picked = Array.from(event.detail?.files || []);
    if (!picked.length || !this.hasInputTarget) return;

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(picked[0]);
    this.inputTarget.files = dataTransfer.files;

    this.element.requestSubmit();
  }
}
